import React from 'react';
import './Card.css';

interface EntropyCardProps {
  entropy: number;
  threatLevel: string;
}

const EntropyCard: React.FC<EntropyCardProps> = ({ entropy, threatLevel }) => {
  const isClean = threatLevel === 'CLEAN';

  const getInterpretation = () => {
    // For clean files, soften the language — high entropy on a clean
    // file just means it's compressed (e.g. a ZIP, installer, etc.)
    if (isClean) {
      if (entropy < 6.0) return { text: 'Normal', color: '#22c55e', description: 'Regular binary structure.' };
      if (entropy < 7.0) return { text: 'Elevated', color: '#6b6b80', description: 'Slightly elevated entropy — common in compressed or optimised files.' };
      return { text: 'Compressed', color: '#6b6b80', description: 'High entropy is normal for compressed or encrypted clean files such as installers.' };
    }

    // For malicious or unknown files, use threat-aware language
    if (entropy < 6.0) return { text: 'Normal', color: '#22c55e', description: 'Regular binary structure, likely not compressed.' };
    if (entropy < 7.0) return { text: 'Suspicious', color: '#eab308', description: 'Elevated entropy — may indicate obfuscation.' };
    return { text: 'Likely packed/encrypted', color: '#ef4444', description: 'High entropy suggests compression or encryption to evade detection.' };
  };

  const interpretation = getInterpretation();
  const percentage = (entropy / 8) * 100;

  return (
    <div className="info-card">
      <h3 className="card-title">📊 Entropy Analysis</h3>
      <div className="entropy-gauge">
        <div className="entropy-value" style={{ color: interpretation.color }}>
          {entropy.toFixed(4)}
        </div>
        <div className="entropy-scale">
          <div className="entropy-bar-container">
            <div
              className="entropy-bar"
              style={{
                width: `${percentage}%`,
                backgroundColor: interpretation.color
              }}
            />
          </div>
          <div className="entropy-labels">
            <span>0</span>
            <span>2</span>
            <span>4</span>
            <span>6</span>
            <span>8</span>
          </div>
        </div>
        <div className="entropy-interpretation">
          <div className="interpretation-badge" style={{ backgroundColor: interpretation.color }}>
            {interpretation.text}
          </div>
          <p className="interpretation-description">{interpretation.description}</p>
        </div>
      </div>
    </div>
  );
};

export default EntropyCard;